import { Box, Typography, Button, styled } from '@mui/material';
import { ArticleOutlined, ImageOutlined, VideoLibraryOutlined } from '@mui/icons-material';

const ContentTypeButton = styled(Button)<{ selected: boolean }>(({ theme, selected }) => ({
  height: '90px',
  borderWidth: 2,
  borderStyle: 'solid',
  borderColor: selected ? theme.palette.primary.main : theme.palette.grey[300],
  backgroundColor: selected ? `${theme.palette.primary.main}10` : 'transparent',
  color: selected ? theme.palette.primary.main : theme.palette.text.secondary,
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  '&:hover': {
    borderColor: selected ? theme.palette.primary.main : theme.palette.grey[400],
    backgroundColor: selected ? `${theme.palette.primary.main}15` : `${theme.palette.grey[300]}20`,
  },
}));

export type ContentType = 'article' | 'image' | 'video';

interface ContentTypeSelectorProps {
  value: ContentType;
  onChange: (type: ContentType) => void;
  enabledTypes?: {
    article?: boolean;
    image?: boolean;
    video?: boolean;
  };
}

const ContentTypeSelector = ({
  value,
  onChange,
  enabledTypes = { article: true, image: true, video: true },
}: ContentTypeSelectorProps) => {
  const types = [
    {
      key: 'article' as ContentType,
      icon: ArticleOutlined,
      label: 'Article',
      enabled: enabledTypes.article,
    },
    {
      key: 'image' as ContentType,
      icon: ImageOutlined,
      label: 'Image',
      enabled: enabledTypes.image,
    },
    {
      key: 'video' as ContentType,
      icon: VideoLibraryOutlined,
      label: 'Video',
      enabled: enabledTypes.video,
    },
  ];

  const enabledTypesList = types.filter(t => t.enabled);

  return (
    <>
      <Typography variant="body2" sx={{ mb: 1.5, fontWeight: 500 }}>
        Content Type
      </Typography>
      <Box sx={{ display: 'flex', gap: 2, width: '100%' }}>
        {enabledTypesList.map(({ key, icon: Icon, label }) => (
          <Box key={key} sx={{ flex: 1 }}>
            <ContentTypeButton
              fullWidth
              selected={value === key}
              onClick={() => onChange(key)}
            >
              <Icon sx={{ fontSize: 32 }} />
              <Typography variant="body2" fontWeight={500}>
                {label}
              </Typography>
            </ContentTypeButton>
          </Box>
        ))}
      </Box>
    </>
  );
};

export default ContentTypeSelector;
